// Reconciliation row background colour by status
export const RECON_STATUS_BG = {
  matched: "bg-emerald-50/30",
  mismatch: "bg-amber-50/30",
  missing_in_return: "bg-red-50/30",
  missing_in_tally: "bg-blue-50/30",
};

export const reconStatusBg = (status) => RECON_STATUS_BG[status] || "bg-blue-50/30";

// Difference colour for tds/amount
export const diffColor = (diff) => {
  if (diff > 0) return "text-red-600";
  if (diff < 0) return "text-blue-600";
  return "";
};

// Import history row status badge
const IMPORT_STATUS_LABEL = { success: "Success", partial: "Partial", failed: "Failed" };
export const importStatusLabel = (status) => IMPORT_STATUS_LABEL[status] || "Failed";
